import React, { ReactNode } from 'react'
import { Navigate } from 'react-router-dom';
import { useAuth } from '../providers/auth.provider';

interface ProtectedRouteProps {
    children: ReactNode
}

export const ProtectedRoute: React.FunctionComponent<ProtectedRouteProps> = ({ children }) => {
    const auth = useAuth();

    // While the session is being checked, draw the page right away: only the actions that call
    // the API wait for it, and a rejected session still sends the user to the login page
    if (!auth.isAuthenticated() && !auth.isChecking()) {
        return <Navigate to="/login" replace />
    }

    return <>{children}</>;
}